import React from "react";

import logo from "../assets/logo.svg";

const Hero = () => (
  <div className="text-center hero my-5">
    <h1 className="mb-4">My Website</h1>

    <p className="lead">Welcome to my website hosted by Vercel!</p>
  </div>
);

export default Hero;
